import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

import Bubble from './Bubble/Bubble';
import classes from './WidgetButton.module.css';

class WidgetButton extends Component {

  state= {
    showBubble: true
  }

  hideBubble=()=>{
    this.setState({showBubble: false});
  }

  buttonClicked=()=>{
    this.setState({showBubble: true});
    this.props.click();
  }

  render(){
    let widget = '';

    if (this.props.show){
      widget = (
        <div className={classes.Widget} role="region" aria-labelledby="widgetTitle2">
          <h2 id="widgetTitle2" className="sr-only"> {this.props.t('widget.title')} </h2>
          <Bubble 
            show={this.state.showBubble} 
            close= {this.hideBubble}
            click={this.buttonClicked} 
          />
          <button id="cbWidgetButton"  
            className={classes.WidgetButton} 
            onClick={this.buttonClicked} 
            title= {this.props.t('widget.button.title')}
            aria-labelledby="widgetTitle3">
            <h3 id="widgetTitle3" className="sr-only"> {this.props.t('widget.button.title')} </h3>
            <img alt={this.props.t('widget.button.title')} src='https://iberia-omnichannel-eva.s3.eu-central-1.amazonaws.com/ibot/ico-bot.png'/> 
          </button>
        </div>

      )
    }
  
    return (
      <React.Fragment>
        {widget}
      </React.Fragment>
      )
    }
  }




export default withTranslation('global')(WidgetButton);